import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import GoldDivider from '../components/GoldDivider';
import hotels from '../data/hotels.js';

function formatPrice(val) {
  if (val === null || val === undefined) return '—';
  return `${val} €`;
}

export default function Hotels() {
  const { t, lang } = useLanguage();

  return (
    <div className="page-container">
      {/* Header */}
      <p className="page-tag">{t('hotels.tag')}</p>
      <h1 className="page-title">{t('hotels.title')}</h1>
      <GoldDivider />

      {/* Intro text */}
      <div style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(201,168,76,0.2)',
        borderRadius: '6px',
        padding: '1.5rem 2rem',
        marginBottom: '2.5rem',
        maxWidth: '760px',
        margin: '0 auto 2.5rem',
      }}>
        <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1.1rem',
          color: 'var(--cream)',
          lineHeight: 1.8,
          marginBottom: '1rem',
        }}>
          {t('hotels.intro')}
        </p>
        <p style={{
          fontSize: '0.88rem',
          color: 'rgba(245,233,198,0.65)',
          fontStyle: 'italic',
        }}>
          {t('hotels.platforms_note')}{' '}
          <a href="https://www.booking.com/searchresults.html?ss=Erlangen" target="_blank" rel="noopener noreferrer"
            style={{ color: 'var(--gold)', textDecoration: 'underline' }}>Booking.com</a>
          {' '}{t('hotels.or')}{' '}
          <a href="https://www.airbnb.com/s/Erlangen--Germany" target="_blank" rel="noopener noreferrer"
            style={{ color: 'var(--gold)', textDecoration: 'underline' }}>Airbnb</a>
          {' '}{t('hotels.platforms_suffix')}
        </p>
      </div>

      {/* Reference note */}
      <p style={{
        textAlign: 'center',
        fontSize: '0.78rem',
        color: 'rgba(245,233,198,0.4)',
        letterSpacing: '0.08em',
        marginBottom: '1.5rem',
        fontFamily: "'Cinzel', serif",
        textTransform: 'uppercase',
      }}>
        📍 {t('hotels.reference')}
      </p>

      {/* Table wrapper for horizontal scroll on mobile */}
      <div style={{ overflowX: 'auto', borderRadius: '6px', border: '1px solid rgba(201,168,76,0.15)' }}>
        <table style={{ minWidth: '720px' }}>
          <thead>
            <tr>
              <th style={{ width: '48px', textAlign: 'center' }}>{t('hotels.col_rang')}</th>
              <th>{t('hotels.col_name')}</th>
              <th>{t('hotels.col_address')}</th>
              <th style={{ textAlign: 'center' }}>{t('hotels.col_distance')}</th>
              <th style={{ textAlign: 'center' }}>{t('hotels.col_min')}</th>
              <th style={{ textAlign: 'center' }}>{t('hotels.col_max')}</th>
              <th>{t('hotels.col_note')}</th>
            </tr>
          </thead>
          <tbody>
            {hotels.map((h) => (
              <tr key={h.rang}>
                {/* Rang */}
                <td style={{ textAlign: 'center' }}>
                  <span style={{
                    fontFamily: "'Cinzel', serif",
                    color: 'var(--gold)',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                  }}>
                    {h.rang}
                  </span>
                </td>

                {/* Name */}
                <td>
                  <span style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: '1rem',
                    color: 'var(--cream)',
                    fontWeight: 400,
                  }}>
                    {h.name}
                  </span>
                </td>

                {/* Adresse */}
                <td style={{ fontSize: '0.82rem', color: 'rgba(245,233,198,0.7)' }}>
                  {h.adresse}
                </td>

                {/* Distance */}
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                  <span style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: '0.75rem',
                    color: 'var(--gold-light)',
                    letterSpacing: '0.05em',
                  }}>
                    {h.distanz}
                  </span>
                </td>

                {/* Min price */}
                <td style={{ textAlign: 'center' }}>
                  {h.min !== null ? (
                    <span className="badge badge-sekt">
                      {formatPrice(h.min)}
                    </span>
                  ) : (
                    <span style={{ color: 'rgba(245,233,198,0.3)', fontSize: '0.8rem' }}>—</span>
                  )}
                </td>

                {/* Max price */}
                <td style={{ textAlign: 'center' }}>
                  {h.max !== null ? (
                    <span className="badge" style={{
                      background: 'rgba(255,255,255,0.06)',
                      color: 'rgba(245,233,198,0.75)',
                    }}>
                      {formatPrice(h.max)}
                    </span>
                  ) : (
                    <span style={{ color: 'rgba(245,233,198,0.3)', fontSize: '0.8rem' }}>—</span>
                  )}
                </td>

                {/* Note / Particularité */}
                <td style={{
                  fontSize: '0.82rem',
                  color: 'rgba(245,233,198,0.65)',
                  fontStyle: 'italic',
                  maxWidth: '240px',
                  lineHeight: 1.5,
                }}>
                  {h.note}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer note */}
      <p style={{
        textAlign: 'center',
        marginTop: '2rem',
        fontSize: '0.78rem',
        color: 'rgba(245,233,198,0.35)',
        fontStyle: 'italic',
      }}>
        {t('hotels.price_note')}
      </p>
    </div>
  );
}
